export default class FileReaderService {
  public async readFile(file, resultArray): Promise<any> {
    await this.delay();
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      resultArray.push({
        fileName: file.name,
        contents: String(reader.result).split(',')[1]
      });
    };
  }

  public async readDocument(file, resultArray): Promise<any> {
    await this.delay();
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      let filetype = String(reader.result).split(';')[0];
      console.log('data \n', String(reader.result).split(',')[1]);

      resultArray.push({
        title: file.name,
        mimeType: '.' + String(filetype).split('/')[1],
        dataContentType: String(filetype).split(':')[1],
        fileName: file.name,
        data: String(reader.result).split(',')[1],
        size: 0
      });
    };
  }

  private delay() {
    return new Promise(resolve => setTimeout(resolve, 1000));
  }
}
